import Http, { paramsSerializer } from "@/config/axios.js"
import { to } from "await-to-js"

export default {
	async list(params) {
		params._method = "GET"
		return to(Http.post(window.API_PREFIX + "/shipments", { ...params, paramsSerializer }))
	},
	async get(id) {
		return to(Http(window.API_PREFIX + `/shipments/${id}`))
	},
	async analyze(params) {
		return to(Http(window.API_PREFIX + "/shipments-analyze", params))
	},
	async find(identification) {
		return to(Http(window.API_PREFIX + `/find-shipment/${identification}`))
	},
	async create(params) {
		return to(Http(window.API_PREFIX + `/shipments/create`, { params }))
	},
	async edit(id, params = {}) {
		return to(Http(window.API_PREFIX + `/shipments/${id}/edit`, { params }))
	},
	async insert(data) {
		return to(Http.post(window.API_PREFIX + `/shipments`, data))
	},
	async update(id, data) {
		data.append("_method", "PATCH")
		return to(Http.post(window.API_PREFIX + `/shipments/${id}`, data))
	},
	async save(data, id) {
		return id ? this.update(id, data) : this.insert(data)
	},
	async delete(id) {
		return to(Http.post(window.API_PREFIX + `/shipments/${id}`, { "_method": "delete" }))
	},
	async eventList(id, params) {
		return to(Http(window.API_PREFIX + `/shipments/${id}/feed`, { params }))
	},
	async addEvent(id, data) {
		return to(Http.post(window.API_PREFIX + `/shipments/${id}/feed`, data))
	},
	async removeEvent(id, eventId) {
		return to(Http.post(window.API_PREFIX + `/shipments/${id}/feed/${eventId}`, { "_method": "DELETE" }))
	},
	async bulkAddEvent(ids, shipment_event) {
		return to(Http.post(window.API_PREFIX + `/shipments-feed`, { ids, ...shipment_event }))
	},
	async listServices(id, params) {
		return to(Http(window.API_PREFIX + `/shipments/${id}/services`, { params }))
	},
	async bulkCancel(ids) {
		return to(Http.post(window.API_PREFIX + `/shipments-cancel`, { ids, "_method": "delete" }))
	},
	async bulkDelete(ids) {
		return to(Http.post(window.API_PREFIX + `/shipments-delete`, { ids, "_method": "delete" }))
	},
	async track(code) {
		return to(Http(`/track-shipment/${code}`))
	},
	async confirm(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-confirm`, params))
	},
	async picking(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-picking`, params))
	},
	async separate(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-separate`, params))
	},
	async collect(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-collect`, params))
	},
	async cancel(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-cancel`, params))
	},
	async draft(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-draft`, params))
	},
	async manifest(ids) {
		return to(Http.post(window.API_PREFIX + `/manifest-shipments`, { ids }))
	},
	async generateLabels(ids, key) {
		return to(Http(`/shipment-generate-labels`, { params: { ids, key } }))
	},
	async generateInvoices(ids, key) {
		return to(Http(`/shipment-generate-invoices`, { params: { ids, key } }))
	},
	async generateOrders(ids) {
		return to(Http(window.API_PREFIX + `/orders/generate-views`, { params: { ids } }))
	},
	/**
	 * Search shipment address
	 * @param params
	 * @returns {Promise<[(Error | null), (unknown | undefined)]>}
	 */
	async searchDestinationOrigin(params) {
		return to(Http(window.API_PREFIX + `/shipment-origin-destination`, { params }))
	},
	/**
	 *
	 * @param id
	 * @returns {Promise<[(Error | null), (AxiosResponse<any> | undefined)]>}
	 */
	async activityLog(id) {
		return to(Http(window.API_PREFIX + `/shipments/${id}/activity_log`))
	},
	/**
	 * Print label
	 * @param id
	 * @returns {Promise<[(Error | null), (T | undefined)]>}
	 */
	async printLabel(id) {
		return to(Http.post(`/print-label/${id}`))
	},
	/**
	 * Print invoice
	 * @param id
	 * @returns {Promise<[(Error | null), (T | undefined)]>}
	 */
	async printInvoice(id) {
		return to(Http.post(`/print-invoice/${id}`))
	},
	/**
	 * Manual integrate to last mile
	 * @param params
	 * @returns {Promise<[Error | null, T | undefined]>}
	 */
	async integrateLastmile(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-integrate-lastmile`, params))
	},
	/**
	 * Manual sync tracking
	 * @param params
	 * @returns {Promise<[Error | null, T | undefined]>}
	 */
	async syncTracking(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-sync-tracking`, params))
	},
	/**
	 * Manual change shipment provider
	 * @param params
	 * @returns {Promise<[Error | null, T | undefined]>}
	 */
	async changeProvider(params) {
		return to(Http.post(window.API_PREFIX + `/shipments-change-provider`, params))
	},
	/**
	 * Finalize Shipment
	 * @param id
	 * @returns {Promise<[Error | null, T | undefined]>}
	 */
	async finalize(id) {
		return to(Http.post(window.API_PREFIX + `/shipments/${id}/finalize`))
	},
	/**
	 * Audit Shipment
	 * @param id
	 * @param data
	 * @returns {Promise<[Error | null, T | undefined]>}
	 */
	async audit(id, data) {
		return to(Http.post(window.API_PREFIX + `/shipments/${id}/audit`, data))
	}
}

